import type { Distance, Point } from "@pdfking/math"
import type { ConcretePlotObject } from "../plot/BasePlotObject"
import type { PlotFunction } from "../plot/PlotFunction"

// Specific type for plot_path
export type PlotPath = {
  closed: boolean
  enum: PlotFunction.PLOT_PATH
  points: Point<Distance>[]
} & ConcretePlotObject
